import { makeStyles } from '@material-ui/core/styles';

// Common styles used across container pages
export const useContainerStyles = makeStyles(theme => ({
  root: {
    flexGrow: 1,
  },
  paper: {
    padding: theme.spacing(4),
    textAlign: 'center',
    color: theme.palette.text.secondary,
  },
}));

// Common styles used across card-based components
export const useCardStyles = makeStyles(theme => ({
  root: {
    width: '100%',
    backgroundColor: theme.palette.background.paper,
  },
  listitem: {
    // Empty but kept for potential future use
  },
  notactive: {
    color: theme.palette.text.disabled,
  },
  table: {
    marginBottom: 8,
  },
}));
